module.exports = __webpack_public_path__ + "static/review2-bd90f4f219ab140c5a7896cc5c7fa147.jpeg";